export default function ProjectCard({ project }) {
  const { id, title, status, statusColor, tag, centre, eta, stage, progress } = project;

  return (
    <div className="border border-gray-100 rounded-xl p-5">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-3">
        <div className="flex items-center gap-3 flex-wrap">
          <h3 className="font-bold text-gray-900">{title}</h3>
          <span className="text-[11px] font-mono bg-gray-100 text-gray-500 px-2 py-0.5 rounded-md">
            {id}
          </span>
          <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${statusColor}`}>
            {status}
          </span>
        </div>
        <div className="text-right">
          <p className="text-xs text-gray-500">{stage}</p>
          <p className="font-bold text-gray-900">{progress}%</p>
        </div>
      </div>

      <p className="text-sm text-gray-500 mb-3">
        {tag} · {centre} · ETA {eta}
      </p>

      <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-[#0f1229] rounded-full"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}